export const viewTitle = "Список проектов описей дел";
export const viewUniqKey = "expertReviewCommissionProtocolsView";
